/**
 * Modal Component
 *
 * Abstraction layer over MUI Modal.
 * Base component for dialogs and overlays.
 */

import { Modal as MuiModal, ModalProps } from '@mui/material';
import React from 'react';

const Modal = React.forwardRef<HTMLDivElement, ModalProps>((props, ref) => {
  return <MuiModal ref={ref} {...props} />;
});

Modal.displayName = 'Modal';

export default Modal;
